export const bookProducts = [
  {
    key: 'bookLaunch',
    title: 'Set of Cards with a Handbook Boxed',
    img: 'https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/WhatsApp%20Image%202026-01-19%20at%2010.57.25%20AM%20(1)%20(1).jpeg',
    price: 150,
    description:
      'A collector release featuring Mana\'s personal meditations, practices, and reflections for grounding anywhere you go. The hardcover set includes luxe chapter art and gilded edges.',
    highlights: ['Collector art spread', 'Handbound guidebook', 'Limited first run'],
    gallery: [
      'https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/WhatsApp%20Image%202026-01-19%20at%2010.57.25%20AM%20(2).jpeg',
      'https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/WhatsApp%20Image%202026-01-19%20at%2010.57.26%20AM%20(1)%20(1).jpeg',
      'https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/WhatsApp%20Image%202026-01-19%20at%2010.57.26%20AM%20(2)%20(1).jpeg',
      'https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/WhatsApp%20Image%202026-01-19%20at%2010.57.26%20AM%20(3).jpeg',
    ],
    isLaunchProduct: true,
  },
  {
    key: 'book1',
    title: 'NEO-SUFISM: DERVISH IN A SUIT',
    img: 'https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/Screenshot-2025-12-30-144256.png',
    price: 25,
    description:
      'A modern exploration of Sufi wisdom adapted for contemporary life. Discover how ancient mystical practices can transform your daily routine, blending spiritual depth with professional success.',
    highlights: ['Modern Sufi teachings', 'Practical applications', 'Spiritual transformation'],
  },
  {
    key: 'book2',
    title: 'The Funny Book of Babies , Babies , Babies',
    img: 'https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/Screenshot-2025-12-30-144310.png',
    price: 25,
    description:
      'A delightful and humorous collection celebrating the joy, chaos, and wonder of babies. Filled with funny anecdotes, adorable moments, and heartwarming stories that will make you smile.',
    highlights: ['Humorous anecdotes', 'Heartwarming stories', 'Perfect gift book'],
  },
  {
    key: 'book3',
    title: 'ZEN',
    img: 'https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/Screenshot-2025-12-30-144324.png',
    price: 25,
    description:
      'A concise guide to Zen philosophy and meditation. Learn the art of mindfulness, inner peace, and living in the present moment through timeless wisdom and practical techniques.',
    highlights: ['Zen philosophy', 'Meditation techniques', 'Mindfulness practices'],
  },
  {
    key: 'book4',
    title: 'The Greatest Quotes From A Mind Tangled',
    img: 'https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/Screenshot-2025-12-30-144349.png',
    price: 25,
    description:
      'A curated collection of profound and thought-provoking quotes from a complex mind. These words of wisdom, confusion, and insight will challenge your perspective and inspire deep reflection.',
    highlights: ['Thought-provoking quotes', 'Deep insights', 'Philosophical reflections'],
  },
  {
    key: 'book5',
    title: 'The Shoe Giant',
    img: 'https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/Screenshot-2025-12-30-144403.png',
    price: 25,
    description:
      'An enchanting tale about a giant who lives among shoes. This whimsical story explores themes of belonging, size, and finding your place in a world that seems too small or too large.',
    highlights: ['Whimsical storytelling', 'Heartfelt narrative', 'Universal themes'],
  },
];
